import type { GetContractsResponse } from "@repo/api";
import type { UseQueryResult } from "@tanstack/react-query";
import { useState } from "react";
import { shouldShowPensionBanner } from "../calculations/pension";
import { useQueryEvents } from "./useQueryEvents";

export const usePensionBanner = (contractsQuery: UseQueryResult<GetContractsResponse[], unknown>) => {
    const [showBanner, setShowBanner] = useState(false);
    const { isSuccess } = contractsQuery;

    useQueryEvents(contractsQuery, {
        onSuccess: (contracts) => {
            setShowBanner(shouldShowPensionBanner(contracts));
        },
    });

    return {
        showBanner,
        isLoading: !isSuccess,
    };
};
